import { 
    CreateQuoteActivityDto, 
    DeleteQuoteActivityDto,
    EditQuoteActivityDto,
    GetQuoteActivityDto, 
    MessageResponseDto, 
    QuoteActivityApiFp,
    QuoteActivityControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseQuoteActivityModel = QuoteActivityControllerGet200Response;
export type GetQuoteActivityModel = GetQuoteActivityDto;
export type MutateResponseQuoteActivityModel = MessageResponseDto;
export type CreateQuoteActivityModel = CreateQuoteActivityDto;
export type UpdateQuoteActivityModel = EditQuoteActivityDto;
export type DeleteQuoteActivityModel = DeleteQuoteActivityDto;

export const apiQuoteActivityFp = QuoteActivityApiFp(apiConfig);
export const getQuoteActivityController = apiQuoteActivityFp.quoteActivityControllerGet;
export const createQuoteActivityController = apiQuoteActivityFp.quoteActivityControllerCreate;
export const updateQuoteActivityController = apiQuoteActivityFp.quoteActivityControllerEdit;
export const deleteQuoteActivityController = apiQuoteActivityFp.quoteActivityControllerDelete;

export const QueryKeyQuoteActivity = QueryKey.QuoteActivity;